import { useDateFormat } from '@enterprise/hooks';

import type { DateFormatProps } from './types/date-format.props';

/**
 * React component for formatting and displaying a date value using a specified format.
 *
 * @param {DateFormatProps} props - The props for the DateFormat component.
 * @param {string} props.format - The date format string to use for formatting the value.
 * @param {Date | string | number} props.value - The date value to be formatted.
 * @returns {JSX.Element} A span element containing the formatted date.
 *
 * @example
 * <DateFormat value={new Date()} format="MM/dd/yyyy" />
 */
export const DateFormat = ({ format, value, ...props }: DateFormatProps) => {
  return <span {...props}>{useDateFormat(value, format)}</span>;
};
